module.exports = __webpack_public_path__ + "img/Check.8d2b6bd4.svg";